import { useContext, useEffect, useState } from 'react';
import { Autocomplete, Loader, Skeleton } from '@mantine/core';
import { EventS } from '../../Service/EventS';
import { EventContext } from '../../Service/Context/EventContext';

const LeadOriginSelect = () => {
  const { event, loadingEvent, saveEvent } = useContext<any>(EventContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<string[]>([]);
  const { leadOrigin } = event ?? {};

  useEffect(() => {
    setLoading(true);
    EventS.fetchLeadOrigins()
      .then(setData)
      .finally(() => setLoading(false));
  }, []);

  if (loadingEvent) {
    return <Skeleton height={40} />;
  }

  if (!event || leadOrigin === undefined) return null;

  return (
    <Autocomplete
      mt="sm"
      onBlur={(e) => saveEvent({ leadOrigin: e.currentTarget.value })}
      rightSection={loading && <Loader size="xs" />}
      data={data}
      defaultValue={leadOrigin ?? ''}
      label="Aufmerksam geworden durch"
    />
  );
};

export default LeadOriginSelect;
